import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from '../locales/en/translation.json';
import ptTranslation from '../locales/pt/translation.json';
import esTranslation from '../locales/es/translation.json';
import deTranslation from '../locales/de/translation.json';
import itTranslation from '../locales/it/translation.json';
import frTranslation from '../locales/fr/translation.json';
import jaTranslation from '../locales/ja/translation.json';
import koTranslation from '../locales/ko/translation.json';
import zhTranslation from '../locales/zh/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  pt: {
    translation: ptTranslation
  },
  es: {
    translation: esTranslation
  },
  de: {
    translation: deTranslation
  },
  it: {
    translation: itTranslation
  },
  fr: {
    translation: frTranslation
  },
  ja: {
    translation: jaTranslation
  },
  ko: {
    translation: koTranslation
  },
  zh: {
    translation: zhTranslation
  }
};

// All languages we ship a full translation bundle for.
export const SUPPORTED_LANGUAGES = ['en', 'pt', 'es', 'it', 'fr', 'de', 'ja', 'ko', 'zh'] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    // Constrain to the languages we actually bundle. Without this, a regional
    // browser code such as `pt-BR`, `es-419` or `zh-CN` was treated as its own
    // language: since no exact resource bundle exists for it, lookups fell
    // straight through to the `en` fallback — so a Brazilian user (navigator
    // `pt-BR`) saw the whole i18n UI in English even though Portuguese is fully
    // translated. `load: 'languageOnly'` strips the region and
    // `nonExplicitSupportedLngs` lets `pt-BR` resolve to the base `pt` bundle.
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'nice-agenda-language'
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace configuration
    ns: ['translation'],
    defaultNS: 'translation',

    // React specific options
    react: {
      useSuspense: false
    }
  });

export default i18n;
